import React, { useState, useEffect } from "react";
import axios from "axios";
import LoaderAnimation from "../lib/loaderAnimation";

export default function CategoriesList() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCategoriesList = async () => {
            try {
                const wpCategories = process.env.REACT_APP_WP_CATEGORIES;
                const url = `${process.env.REACT_APP_WP_API_URL_V2}/categories?include=${wpCategories}`;
                const categoriesResponse = await axios.get(
                    url,
                    {
                        params: {
                            _fields: [
                                'id',
                                'count',
                                'parent',
                                'description',
                                'link',
                                'name',
                                'slug'
                            ],
                        }
                    }
                );

                const filteredCategories = categoriesResponse.data.filter(
                    (category) => category.name && category.name !== "Uncategorized"
                );

                setCategories(filteredCategories);
            } catch (err) {
                setError("Erreur lors de la récupération des données.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchCategoriesList();
    }, []);

    if (error) {
        return <p>{error}</p>;
    }


    return (
        <div>
            <ul className="category-list">
                {loading ? (
                    <LoaderAnimation version={'2'}/>
                ) : (
                    <>
                        {categories.length > 0 ? (
                            categories.map((category) => (
                                <li
                                    key={category.id}
                                    className={`category-item ${
                                        selectedCategory === category.id
                                            ? "active"
                                            : ""
                                    }`}
                                >
                                    <a href={`/blog/categorie/${category.slug}`}>{category.name}</a>
                                </li>
                            ))
                        ) : (
                            <p>Aucune catégorie.</p>
                        )}
                    </>
                )}
            </ul>
        </div>
    );
}
